import Config from "./Config";

export const endpoints = {
  login: `${Config.apiUrl}/auth/login`,
  logout: `${Config.apiUrl}/auth/signout`,
  ordersEndpoint: `${Config.apiUrl}/order`,
  getProductsSearch: `${Config.apiUrl}/product/search`,
  orderOfferEndpoint: `${Config.apiUrl}/orderOffer`,
  getPublicProductsSearch: `${Config.apiUrl}/orderOffer/searchProducts`,
  getPublicPaymentMethods: `${Config.apiUrl}/orderOffer/paymentMethods`,
  getOrderOfferForClient: `${Config.apiUrl}/orderOffer/order`,
  getPublicTransportOptions: `${Config.apiUrl}/orderOffer/transportOptions`,
  rolesEndpoint: `${Config.apiUrl}/role`,
  orderStatus: `${Config.apiUrl}/orderStatus`,
  getProducts: `${Config.apiUrl}/product`,
  syncWordPressData: `${Config.apiUrl}/product/sync`,
  syncWordPressDataOrders: `${Config.apiUrl}/order/sync`,
  emailTemplatesEndpoint: `${Config.apiUrl}/emailTemplate`,
  duplicateOrder: `${Config.apiUrl}/order/duplicate/`,
  contactEndpoint: `${Config.apiUrl}/contact`,
  getDashboardSummaryContacts: `${Config.apiUrl}/contact/dashboard`,
  getAvailableContacts: `${Config.apiUrl}/contact/available`,
  getTakenContacts: `${Config.apiUrl}/contact/taken`,
  associateAgentWithContact: `${Config.apiUrl}/contact/associateAgent`,
  updateOrderNotes: `${Config.apiUrl}/order/notes`,
  updateContactNotes: `${Config.apiUrl}/contact/notes`,
  transportOption: `${Config.apiUrl}/transportOption`,
  whatsAppMetaUrl: "https://graph.facebook.com/v19.0/",
  erpProductsEndpoint: `${process.env.REACT_APP_ERP_URL_BACKEND}/api/products-crm-wp/getProducts`,
  user: {
    main: `${Config.apiUrl}/user`,
    autocomplete: `${Config.apiUrl}/user/filter`,
  },
  media: {
    main: `${Config.apiUrl}/media`,
    delete: `${Config.apiUrl}/media/delete`,
    folder: `${Config.apiUrl}/media/folder`,
    public: `${Config.apiUrl}/media/public`,
    files: `${Config.apiUrl}/media/public?path=`,
  },
  clientCategory: {
    main: `${Config.apiUrl}/clientCategory`,
  },
  audit: {
    main: `${Config.apiUrl}/audit`,
  },
  oblio: {
    main: `${Config.apiUrl}/oblio`,
    syncProducts: `${Config.apiUrl}/oblio/syncProducts`,
    managementNomenclator: `${Config.apiUrl}/oblio/managementNomenclator`,
    cancel: `${Config.apiUrl}/oblio/cancel`,
  },
  whatsApp: {
    main: `${Config.apiUrl}/whatsApp`,
    waba: `${Config.apiUrl}/whatsApp/waba`,
    createPhoneNumber: `${Config.apiUrl}/whatsApp/createPhoneNumber`,
    registerPhoneNumber: `${Config.apiUrl}/whatsApp/registerPhoneNumber`,
    template: `${Config.apiUrl}/whatsApp/template`,
    uploadMedia: `${Config.apiUrl}/whatsApp/uploadMediaContentForHeader`,
    message: `${Config.apiUrl}/whatsApp/message`,
    templateMessage: `${Config.apiUrl}/whatsApp/templateMessage`,
    image: `${Config.apiUrl}/whatsApp/image`,
    sendFileMessage: `${Config.apiUrl}/whatsApp/sendFileMessage`,
  },
  conversation: {
    main: `${Config.apiUrl}/conversation`,
    markConversationAsRead: `${Config.apiUrl}/conversation/markConversationAsRead`,
    unreadConversations: `${Config.apiUrl}/conversation/unreadConversations`,
    associate: `${Config.apiUrl}/conversation/associate`,
  },
  setting: {
    main: `${Config.apiUrl}/setting/`,
    orderSettings: `${Config.apiUrl}/setting/orderSettings/`,
    orderSettingsNumber: `${Config.apiUrl}/setting/orderSettingsNumber/`,
    contact: `${Config.apiUrl}/setting/contactSettings/`,
    clients: `${Config.apiUrl}/setting/clientsSettings/`,
    updateClientsSettings: `${Config.apiUrl}/setting/clients/`,
    wordPress: `${Config.apiUrl}/setting/wordPressSettings`,
    updateWordPress: `${Config.apiUrl}/setting/wordpress/`,
    fgo: `${Config.apiUrl}/setting/fgo/`,
    fgoSettings: `${Config.apiUrl}/setting/fgoSettings/`,
    oblio: `${Config.apiUrl}/setting/oblio/`,
    oblioSettings: `${Config.apiUrl}/setting/oblioSettings/`,
  },
  documentation: {
    main: `${Config.apiUrl}/documentation`,
  },
  client: {
    main: `${Config.apiUrl}/client`,
    search: `${Config.apiUrl}/client/search/`,
    periodicityNames: `${Config.apiUrl}/client/periodicityNames`,
    import: `${Config.apiUrl}/client/import`,
    getANAFData: `${Config.apiUrl}/client/anaf`,
    addressCheckEndpointCity:
      "https://countriesnow.space/api/v0.1/countries/cities",
    addressCheckEndpointState:
      "https://countriesnow.space/api/v0.1/countries/states",
    addressCheckEndpointStateCity:
      "https://countriesnow.space/api/v0.1/countries/state/cities",
  },
  messages: {
    main: `${Config.apiUrl}/client-messages`,
    types: `${Config.apiUrl}/types`,
    statuses: `${Config.apiUrl}/statuses`,
  },

  task: {
    main: `${Config.apiUrl}/task`,
    duplicate: `${Config.apiUrl}/task/duplicate`,
    subtask: `${Config.apiUrl}/task/subtask`,
  },
  alert: {
    main: `${Config.apiUrl}/alert`,
  },
  alertPerEntity: {
    main: `${Config.apiUrl}/alertPerEntity`,
  },
  notifications: {
    main: `${Config.apiUrl}/notifications`,
    markAsRead: `${Config.apiUrl}/notifications/markAsRead`,
  },
  predefined: `${Config.apiUrl}/tags`,
  companies: `${Config.apiUrl}/companies`,

  leadTemplate: {
    main: `${Config.apiUrl}/lead-templates`,
    active: `${Config.apiUrl}/lead-templates/active`,
    sendEmail: `${Config.apiUrl}/lead-templates/send/email`,
    sendEmailBulk: `${Config.apiUrl}/lead-templates/send/email/bulk`,
    sendWhatsApp: `${Config.apiUrl}/lead-templates/send/whatsapp`,
    sendWhatsAppBulk: `${Config.apiUrl}/lead-templates/send/whatsapp/bulk`,
  },
  reports: {
    // Sales endpoints
    salesRevenueTrends: `${Config.apiUrl}/reports/sales/revenue-trends`,
    salesOrdersByStatus: `${Config.apiUrl}/reports/sales/orders-by-status`,
    salesTopProducts: `${Config.apiUrl}/reports/sales/top-products`,
    salesPaymentMethods: `${Config.apiUrl}/reports/sales/payment-methods`,
    salesTopClients: `${Config.apiUrl}/reports/sales/top-clients`,

    // Marketing endpoints
    marketingLeadConversion: `${Config.apiUrl}/reports/marketing/lead-conversion`,
    marketingCampaignPerformance: `${Config.apiUrl}/reports/marketing/campaign-performance`,
    marketingClientSegmentation: `${Config.apiUrl}/reports/marketing/client-segmentation`,
    marketingAgentPerformance: `${Config.apiUrl}/reports/marketing/agent-performance`,

    // Support endpoints
    supportTasksOverview: `${Config.apiUrl}/reports/support/tasks-overview`,
    supportTicketsOverview: `${Config.apiUrl}/reports/support/tickets-overview`,
    supportResponseTimes: `${Config.apiUrl}/reports/support/response-times`,
    supportAgentWorkload: `${Config.apiUrl}/reports/support/agent-workload`,

    // Export endpoints
    exportSales: `${Config.apiUrl}/reports/export/sales`,
    exportMarketing: `${Config.apiUrl}/reports/export/marketing`,
    exportSupport: `${Config.apiUrl}/reports/export/support`,
  },
  supportTickets: {
    base: `${Config.apiUrl}/support-tickets`,
    paginated: `${Config.apiUrl}/support-tickets/paginated`,
    byId: (id: string) => `${Config.apiUrl}/support-tickets/${id}`,
    assign: (id: string) => `${Config.apiUrl}/support-tickets/${id}/assign`,
    updateStatus: (id: string) =>
      `${Config.apiUrl}/support-tickets/${id}/status`,
    addComment: (id: string) =>
      `${Config.apiUrl}/support-tickets/${id}/comment`,
    history: (id: string) => `${Config.apiUrl}/support-tickets/${id}/history`,
    preview: (token: string) =>
      `${Config.apiUrl}/support-tickets/preview/${token}`,
  },
};

export const localUrlEnum: any = {
  login: "/login",
  users: "/users?",
  clients: "/clients?",
  reports: "/reports",
  sales: "/sales",
  orders: "/orders?",
  settings: "/settings",
  messages: "/messages",
  clientMessages: "/clientMessages",
  orderStatus: "/orderStatus?",
  order: "/orders/order",
  client: "/clients/client",
  marketing: "/marketing",
  product: "/products/product",
  supportTickets: "/supportTickets",
  ticketPreview: "/ticket/preview",
  mainRoute: "/",
  tasks: "/tasks",
  dashboard: "/dashboard",
  whatsAppPhoneNumbers: "/whatsApp/phoneNumbers",
  whatsAppTemplates: "/whatsApp/templates",
  whatsAppTemplate: "/whatsApp/template",
  pageNotFound: "*",
  renderChildren: "",
  logs: "/logs",
  alerts: "/alerts",
  products: "/products?",
  contacts: "/contacts",
  emailTemplates: "/emailTemplates?",
  orderOfferPasswordCheck: "/orderOfferPasswordCheck",
  orderOffer: "/orderOffer",
  orderOfferConfirmation: "/orderOfferConfirmation",
  predefined: "/predefined",
  companies: "/companies",
  forms: {
    service: "/forms/service",
  },
};

export const basicOperationsEnum = {
  create: "/create",
  update: "/update",
  delete: "/delete",
  import: "/import",
  export: "/export",
};

export const pathParams = {
  optionalId: "/:id?",
  orderId: "/:orderId",
  page: "/:page",
};

export const foldersNames = {
  usersProfiles: "usersProfiles/",
};

export const MessagesStatus = {
  canceled: "canceled",
  notRead: "notRead",
  completed: "completed",
  inProgress: "inProgress",
  read: "read",
};

export const MessagesType = {
  custody: "custody",
  service: "service",
  other: "other",
};
